import type React from 'react';

import { Box, styled, Typography } from '@mui/material';
import { LogoSpinner } from '@ragu-components/ord-components';

import type { SxProps } from '@mui/material';

interface LoadingProps {
  sx?: SxProps;
}

const DotAnimation = styled(Box)({
  display: 'inline-block',
  '& span': {
    display: 'inline-block',
    animation: 'blink 3s infinite steps(1, end)',
  },
  '@keyframes blink': {
    '0%, 100%': { opacity: 1 },
    '33%': { opacity: 0 },
  },
  '& span:nth-of-type(1)': { animationDelay: '0s' },
  '& span:nth-of-type(2)': { animationDelay: '1s' },
  '& span:nth-of-type(3)': { animationDelay: '2s' },
});

export const Loading = ({ sx = undefined }: LoadingProps): React.ReactElement => {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
    >
      <LogoSpinner />
      <Typography variant='overline' mt={2}>
        Loading{' '}
        <DotAnimation>
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </DotAnimation>
      </Typography>
    </Box>
  );
};
